import { Variant } from '../Typography/index.js';
import Link from './index.js';

interface EmailLinkProps {
  children: string;
  variant?: Variant;
}

export default function EmailLink({ children, variant = 'body' }: EmailLinkProps): JSX.Element {
  return (
    <Link
      external
      to={`mailto:${children}`}
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
    >
      {children}
    </Link>
  );
}

export function emailLinkMarkdown(email: string): string {
  return `[${email}](mailto:${email})`;
}
